// extracted by mini-css-extract-plugin
export default {"singleProject":"SingleProject_singleProject__e2sPL","actionIcons":"SingleProject_actionIcons__r8ELC"};